(function(){
  var src=document.getElementById('kmst-src');
  var grid=document.getElementById('kmst-grid');
  var q=document.getElementById('kmst-q');
  if(!src||!grid||!q)return;
  var rad=document.getElementById('kmst-radius');
  var near=document.getElementById('kmst-near');
  var none=document.getElementById('kmst-none');

  var TAG={'master':'Master Certified','founder':'Founder / CEO','lead-educator':'Lead Educator','educator':'Educator'};
  // Master is not in ROLE_ORDER: it is a certification, so it renders beside
  // the Mesh / Meshless badge rather than as a role. ROLE_ORDER is highest
  // first and the loop breaks on the first hit, so a lead educator reads
  // "Lead Educator" and not that plus "Educator".
  var ROLE_ORDER=['founder','lead-educator','educator'];
  var MASTER='<span class="kmst-master">Master Certified</span>';

  var rows=[];
  var lines=src.textContent.split('\n');
  for(var i=0;i<lines.length;i++){
    var t=lines[i].trim();
    if(!t)continue;
    var f=t.split('|');
    var tags=[];
    var raw=(f[10]||'').split(',');
    for(var g=0;g<raw.length;g++){
      var tg=raw[g].trim().toLowerCase();
      // Ignore anything not in the vocabulary rather than rendering an
      // unstyled badge from a typo in the roster.
      if(TAG[tg]&&tags.indexOf(tg)<0)tags.push(tg);
    }
    rows.push({n:f[0],cert:f[1]||'meshless',addr:f[2],lat:parseFloat(f[3]),lng:parseFloat(f[4]),ig:f[5],book:f[6],tel:f[7],region:f[8],abbr:f[9]||'',tags:tags});
  }
  var LABEL={both:'Mesh and Meshless Certified',mesh:'Mesh Certified',meshless:'Meshless Certified'};
  var userLoc=null,geoMode=false,map=null,markers=[];

  function esc(s){var d=document.createElement('div');d.textContent=(s==null?'':s);return d.innerHTML;}
  function key(r){
    var t='';
    for(var i=0;i<r.tags.length;i++){t+=' '+TAG[r.tags[i]];}
    return (r.n+' '+r.addr+' '+r.region+' '+r.abbr+t).toLowerCase();
  }
  function dist(r,la,ln){
    if(isNaN(r.lat)||isNaN(r.lng))return 999999;
    var dLa=(r.lat-la)*Math.PI/180,dLn=(r.lng-ln)*Math.PI/180;
    var a=Math.sin(dLa/2)*Math.sin(dLa/2)+Math.cos(la*Math.PI/180)*Math.cos(r.lat*Math.PI/180)*Math.sin(dLn/2)*Math.sin(dLn/2);
    return 3959*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
  }
  function card(r,d){
    var h='<div class="kmst-card" data-lat="'+r.lat+'" data-lng="'+r.lng+'">';
    for(var t=0;t<ROLE_ORDER.length;t++){
      var tg=ROLE_ORDER[t];
      if(r.tags.indexOf(tg)<0)continue;
      h+='<div class="kmst-role kmst-role--'+tg+'"><i>✦</i>'+TAG[tg]+'<i>✦</i></div>';
      break;                       // highest role only, never two stacked
    }
    h+='<h4>'+(r.tags.indexOf('master')>-1?'<span class="kmst-mark">◆</span>':'')+esc(r.n)+'</h4>';
    var creds=(r.tags.indexOf('master')>-1?MASTER:'')
      + '<span class="kmst-cert kmst-cert--'+esc(r.cert)+'">'+(LABEL[r.cert]||LABEL.meshless)+'</span>';
    h+='<div class="kmst-creds">'+creds+'</div>';
    if(d==null){h+='<p class="kmst-dist"></p>';}
    else{h+='<p class="kmst-dist" style="display:block">'+Math.round(d)+' miles away</p>';}
    h+='<p class="kmst-addr">'+esc(r.addr)+'</p>';
    if(!isNaN(r.lat)&&!isNaN(r.lng)){h+='<a class="kmst-btn kmst-btn--primary" href="https://www.google.com/maps/search/?api=1&query='+r.lat+','+r.lng+'" target="_blank" rel="noopener">Directions</a>';}
    if(r.ig){h+='<a class="kmst-btn" href="'+esc(r.ig)+'" target="_blank" rel="noopener">Instagram</a>';}
    if(r.book){h+='<a class="kmst-btn" href="'+esc(r.book)+'" target="_blank" rel="noopener">Book</a>';}
    if(r.tel){h+='<a class="kmst-btn" href="tel:'+esc(r.tel)+'">Call</a>';}
    return h+'</div>';
  }

  function render(){
    var v=q.value.toLowerCase().trim();
    var R=(rad&&rad.value)?parseFloat(rad.value):0;
    var html='',shown=0;
    if(geoMode&&userLoc){
      var list=[];
      for(var i=0;i<rows.length;i++){list.push({r:rows[i],d:dist(rows[i],userLoc[0],userLoc[1])});}
      list.sort(function(a,b){return a.d-b.d;});
      for(var j=0;j<list.length;j++){
        if(R&&list[j].d>R)continue;
        html+=card(list[j].r,list[j].d);shown++;
      }
    }else{
      var counts={};
      for(var k=0;k<rows.length;k++){
        if(v&&key(rows[k]).indexOf(v)<0)continue;
        counts[rows[k].region]=(counts[rows[k].region]||0)+1;
      }
      var cur='';
      for(var m=0;m<rows.length;m++){
        var r=rows[m];
        if(v&&key(r).indexOf(v)<0)continue;
        if(r.region!==cur){cur=r.region;html+='<h3 class="kmst-region">'+esc(cur)+' <span>('+counts[cur]+')</span></h3>';}
        html+=card(r,null);shown++;
      }
    }
    grid.innerHTML=html;
    if(none){none.style.display=shown?'none':'block';}
    syncMap(v);
    return shown;
  }

  function syncMap(v){
    if(!map)return;
    var b=[];
    for(var i=0;i<markers.length;i++){
      var mk=markers[i];
      var hit=geoMode||!v||mk._kq.indexOf(v)>-1;
      if(hit){mk.addTo(map);b.push(mk.getLatLng());}else{map.removeLayer(mk);}
    }
    if(geoMode&&userLoc){map.setView(userLoc,8);}
    else if(v&&b.length){map.fitBounds(b,{padding:[40,40],maxZoom:11});}
    else if(!v){map.setView([39.5,-96],4);}
  }

  var cache={};
  function isZip(s){
    if(s.length!==5)return false;
    for(var i=0;i<5;i++){if(s.charAt(i)<'0'||s.charAt(i)>'9')return false;}
    return true;
  }
  function geocode(s,cb){
    var k=s.toLowerCase();
    if(cache[k]!==undefined)return cb(cache[k]);
    var url='https://nominatim.openstreetmap.org/search?format=json&limit=1&q='+encodeURIComponent(s);
    fetch(url).then(function(res){return res.json();}).then(function(d){
      cache[k]=(d&&d.length)?[parseFloat(d[0].lat),parseFloat(d[0].lon)]:null;
      cb(cache[k]);
    }).catch(function(){cache[k]=null;cb(null);});
  }
  function tryGeo(v){
    if(!v)return;
    geocode(v,function(loc){
      if(!loc)return;
      if(q.value.trim().toLowerCase()!==v.toLowerCase())return;
      userLoc=loc;geoMode=true;render();
    });
  }

  var timer=null;
  q.addEventListener('input',function(){
    if(timer)clearTimeout(timer);
    var v=q.value.trim();
    geoMode=false;
    if(!v){userLoc=null;render();return;}
    var shown=render();
    if(isZip(v)||(shown===0&&v.length>3)){
      timer=setTimeout(function(){tryGeo(v);},900);
    }
  });
  q.addEventListener('keydown',function(e){
    if(e.key==='Enter'||e.keyCode===13){
      e.preventDefault();
      if(timer)clearTimeout(timer);
      tryGeo(q.value.trim());
    }
  });
  if(rad){
    rad.addEventListener('change',function(){
      if(rad.value&&!userLoc){near.click();return;}
      render();
    });
  }
  if(near){
    near.addEventListener('click',function(){
      if(!navigator.geolocation)return;
      navigator.geolocation.getCurrentPosition(function(pos){
        userLoc=[pos.coords.latitude,pos.coords.longitude];
        geoMode=true;render();
        window.scrollTo({top:grid.offsetTop-140,behavior:'smooth'});
      },function(){
        alert('Could not get your location. Try searching by city, state, or ZIP instead.');
      });
    });
  }

  function initMap(){
    if(!window.L)return setTimeout(initMap,300);
    map=L.map('kmst-map').setView([39.5,-96],4);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; OpenStreetMap contributors'}).addTo(map);
    for(var i=0;i<rows.length;i++){
      var r=rows[i];
      if(isNaN(r.lat)||isNaN(r.lng))continue;
      var mk=L.marker([r.lat,r.lng]).addTo(map).bindPopup('<strong>'+esc(r.n)+'</strong><br>'+esc(r.addr)+'<br><a href="https://www.google.com/maps/search/?api=1&query='+r.lat+','+r.lng+'" target="_blank" rel="noopener">Directions</a>');
      mk._kq=key(r);
      markers.push(mk);
    }
  }

  render();
  initMap();
})();
